import {i18n} from "@/plugins/i18n";

export const shebaNumberShaparakStatus = {
    DOES_NOT_SEND: 1,
    CONFIRMED: 2,
}

export const shebaNumberShaparakStatusStr = {
    DOES_NOT_SEND: i18n.t('sheba_number_shaparak_status.does_not_send'),
    CONFIRMED: i18n.t('sheba_number_shaparak_status.confirmed'),

    get(status) {
        let status_str = null;
        Object.keys(shebaNumberShaparakStatus).forEach(function (item) {
            if(shebaNumberShaparakStatus[item] === status) {
                status_str = shebaNumberShaparakStatusStr[item]
            }
        })

        return status_str
    }
}